import { render, staticRenderFns } from "./ProductCollection.vue?vue&type=template&id=310e56bf&"
import script from "./ProductCollection.vue?vue&type=script&lang=ts&"
export * from "./ProductCollection.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports